import { render, staticRenderFns } from "./pirates-instruments.vue?vue&type=template&id=7f321883&scoped=true&"
import script from "./pirates-instruments.vue?vue&type=script&lang=js&"
export * from "./pirates-instruments.vue?vue&type=script&lang=js&"
import style0 from "./pirates-instruments.vue?vue&type=style&index=0&id=7f321883&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f321883",
  null
  
)

export default component.exports